(function(){
  const bar=document.querySelector('[data-th-announcement]');
  if(!bar)return;
  const slides=Array.from(bar.querySelectorAll('[data-th-announcement-slide]'));
  const pause=bar.querySelector('[data-th-announcement-pause]');
  const motion=window.matchMedia('(prefers-reduced-motion: reduce)');
  let index=0, timer=null, stopped=motion.matches, hovered=false;
  function sync(){
    clearInterval(timer);
    pause.setAttribute('aria-pressed',String(stopped));
    pause.setAttribute('aria-label',stopped?pause.dataset.playLabel:pause.dataset.pauseLabel);
    pause.firstElementChild.textContent=stopped?'▶':'Ⅱ';
    if(!stopped&&!hovered&&!bar.contains(document.activeElement)&&!document.hidden)timer=setInterval(()=>show(index+1),6000);
  }
  function show(next){
    index=(next+slides.length)%slides.length;
    slides.forEach((slide,i)=>{slide.hidden=i!==index});
  }
  bar.querySelector('[data-th-announcement-prev]').addEventListener('click',()=>{show(index-1);sync()});
  bar.querySelector('[data-th-announcement-next]').addEventListener('click',()=>{show(index+1);sync()});
  pause.addEventListener('click',()=>{stopped=!stopped;sync()});
  bar.addEventListener('mouseenter',()=>{hovered=true;sync()});
  bar.addEventListener('mouseleave',()=>{hovered=false;sync()});
  bar.addEventListener('focusin',sync);
  bar.addEventListener('focusout',()=>setTimeout(sync,0));
  document.addEventListener('visibilitychange',sync);
  motion.addEventListener('change',()=>{stopped=motion.matches;sync()});
  sync();
})();
(function(){
  const menu=document.querySelector('.th-desktop-nav');
  const hamburger=document.querySelector('.th-header-menu');
  if(!menu)return;
  const items=Array.from(menu.querySelectorAll('.th-desktop-nav__item'));
  const desktop=window.matchMedia('(min-width:990px)');
  const hover=window.matchMedia('(hover:hover) and (pointer:fine)');
  items.forEach(item=>{
    item.addEventListener('mouseenter',()=>{if(desktop.matches&&hover.matches){if(hamburger)hamburger.open=false;items.forEach(other=>{other.open=other===item})}});
    item.addEventListener('mouseleave',()=>{if(hover.matches&&!item.contains(document.activeElement))item.open=false});
    item.addEventListener('toggle',()=>{if(item.open&&hamburger)hamburger.open=false});
    item.addEventListener('focusout',()=>setTimeout(()=>{if(!item.contains(document.activeElement))item.open=false},0));
  });
  if(hamburger)hamburger.addEventListener('toggle',()=>{if(hamburger.open)items.forEach(item=>item.open=false)});
  document.addEventListener('click',event=>{if(!menu.contains(event.target))items.forEach(item=>item.open=false)});
  document.addEventListener('keydown',event=>{if(event.key==='Escape'){const active=items.find(item=>item.open);if(active){active.open=false;active.querySelector('summary').focus()}}});
  desktop.addEventListener('change',()=>{if(!desktop.matches)items.forEach(item=>item.open=false)});
})();


(function(){const menu=document.querySelector('.th-header-menu');if(!menu)return;document.addEventListener('keydown',e=>{if(e.key==='Escape'&&menu.open){menu.open=false;menu.querySelector('summary').focus()}});document.addEventListener('click',e=>{if(menu.open&&!menu.contains(e.target))menu.open=false})})();